import heroImage from '../../assets/apartment_building.jpg';

/**
 * Full-bleed building photo as the hero's background, with a teal gradient
 * overlay for text contrast and the headline set over it — shorter and
 * bolder than the original side-by-side layout, per user feedback.
 */
export function Hero() {
  return (
    <section className="public__hero">
      <img className="public__hero-bg" src={heroImage} alt="" />
      <div className="public__hero-text">
        <h1>Find your Dream Rental.</h1>
      </div>
    </section>
  );
}
